import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SystemModule } from './types/permissions';
import Login from './components/Auth/Login';
import ResetPassword from './components/Auth/ResetPassword';
import ConfirmEmail from './components/Auth/ConfirmEmail';
import Dashboard from './components/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';
import LoadingSpinner from './components/Common/LoadingSpinner';
import PermissionRoute from './components/Route/PermissionRoute';
import AccessDenied from './pages/Error/AccessDenied';
import NotFound from './pages/Error/NotFound';
import Checklists from './pages/Checklists/Checklists';
import Drivers from './pages/Drivers/Drivers';
import Vehicles from './pages/Vehicles/Vehicles';
import Equipment from './pages/Equipment/Equipment';
import Obras from './pages/Work/Obras';
import ObraView from './pages/Work/View/ObraView';
import ObraCreate from './pages/Work/Create/ObraCreate';
import ObraEdit from './pages/Work/Edit/ObraEdit';
import ChecklistItems from './pages/ChecklistItems/ChecklistItems';
import ChecklistItemView from './pages/ChecklistItems/View/ChecklistItemView';
import ChecklistItemCreate from './pages/ChecklistItems/Create/ChecklistItemCreate';
import ChecklistItemEdit from './pages/ChecklistItems/Edit/ChecklistItemEdit';
import DriverView from './pages/Drivers/View/DriverView';
import DriverCreate from './pages/Drivers/Create/DriverCreate';
import DriverEdit from './pages/Drivers/Edit/DriverEdit';
import VehicleView from './pages/Vehicles/View/VehicleView';
import VehicleCreate from './pages/Vehicles/Create/VehicleCreate';
import VehicleEdit from './pages/Vehicles/Edit/VehicleEdit';
import EquipmentView from './pages/Equipment/View/EquipmentView';
import EquipmentCreate from './pages/Equipment/Create/EquipmentCreate';
import EquipmentEdit from './pages/Equipment/Edit/EquipmentEdit';
import ChecklistGroupView from './pages/ChecklistGroups/View/ChecklistGroupView';
import OccurrenceView from './pages/Occurrences/View/OccurrenceView';
import ChecklistView from './pages/Checklists/View/ChecklistView';
import ChecklistCreate from './pages/Checklists/Create/ChecklistCreate';
import ChecklistEdit from './pages/Checklists/Edit/ChecklistEdit';
import ScheduleView from './pages/Schedules/View/ScheduleView';
import ScheduleForm from './pages/Schedules/Create/ScheduleForm';
import FuelingView from './pages/Fueling/View/FuelingView';
import FuelingCreate from './pages/Fueling/Create/FuelingCreate';
import FuelingEdit from './pages/Fueling/Edit/FuelingEdit';
import ImportHistory from './pages/Fueling/ImportHistory';
import ProductivityView from './pages/Productivity/View/ProductivityView';
import ProductivityCreate from './pages/Productivity/Create/ProductivityCreate';
import PreventiveMaintenanceView from './pages/PreventiveMaintenance/View/PreventiveMaintenanceView';
import PreventiveMaintenanceCreate from './pages/PreventiveMaintenance/Create/PreventiveMaintenanceCreate';
import CorrectiveMaintenanceView from './pages/CorrectiveMaintenance/View/CorrectiveMaintenanceView';
import CorrectiveMaintenanceCreate from './pages/CorrectiveMaintenance/Create/CorrectiveMaintenanceCreate';
import Tires from './pages/Tires/Tires';
import TireCreate from './pages/Tires/Create/TireCreate';
import TireView from './pages/Tires/View/TireView';
import Compliance from './pages/Compliance/Compliance';
import TCO from './pages/TCO/TCO';
import ChecklistGroups from './pages/ChecklistGroups/ChecklistGroups';
import ChecklistGroupCreate from './pages/ChecklistGroups/Create/ChecklistGroupCreate';
import ChecklistGroupEdit from './pages/ChecklistGroups/Edit/ChecklistGroupEdit';
import Occurrences from './pages/Occurrences/Occurrences';
import OccurrenceCreate from './pages/Occurrences/Create/OccurrenceCreate';
import OccurrenceEdit from './pages/Occurrences/Edit/OccurrenceEdit';
import Schedules from './pages/Schedules/Schedules';
import Fueling from './pages/Fueling/Fueling';
import Productivity from './pages/Productivity/Productivity';
import PreventiveMaintenance from './pages/PreventiveMaintenance/PreventiveMaintenance';
import CorrectiveMaintenance from './pages/CorrectiveMaintenance/CorrectiveMaintenance';
import Settings from './pages/Settings/Settings';
import WhatsApp from './pages/Settings/WhatsApp';
import ContatosNaoIdentificados from './components/WhatsApp/ContatosNaoIdentificados';
import UserManagement from './pages/Settings/Users/UserManagement';
import CompanySettings from './pages/Settings/CompanySettings';
import Backup from './pages/Settings/Backup';
import IntegrationSettings from './pages/Integrations/IntegrationSettings';
import UserProfile from './pages/Profile/UserProfile';
import PrivacySettings from './pages/Privacy/PrivacySettings';
import Notifications from './pages/Notifications/Notifications';
import EquipmentProductivity from './pages/Reports/EquipmentProductivity';
import ChecklistsReport from './pages/Reports/ChecklistsReport';
import VehiclesReport from './pages/Reports/VehiclesReport';
import OccurrencesReport from './pages/Reports/OccurrencesReport';
import FuelReport from './pages/Reports/FuelReport';
import AutomationList from './pages/Automations/AutomationList';
import AutomationCreate from './pages/Automations/AutomationCreate';
import AutomationEdit from './pages/Automations/AutomationEdit';
import AutomationExecutions from './pages/Automations/AutomationExecutions';
import FlowSimulatorPage from './pages/Automations/FlowSimulatorPage';
import QRScanner from './pages/Public/QRScanner';
import ClientesList from './pages/Clientes/ClientesList';
import ClienteCreate from './pages/Clientes/Create/ClienteCreate';
import ClienteEdit from './pages/Clientes/Edit/ClienteEdit';
import ClienteView from './pages/Clientes/View/ClienteView';
import ConferenciaList from './pages/Conferencia/ConferenciaList';
import ConferenciaCreate from './pages/Conferencia/Create/ConferenciaCreate';
import ConferenciaView from './pages/Conferencia/View/ConferenciaView';
import ConferenciaScanner from './pages/Conferencia/Scanner/ConferenciaScanner';
import ConferenciaEdit from './pages/Conferencia/Edit/ConferenciaEdit';
import ConferenciaProdutividade from './pages/Conferencia/Produtividade/ConferenciaProdutividade';
import ConferenciaProdutividadeDetalhe from './pages/Conferencia/Produtividade/ConferenciaProdutividadeDetalhe';
import ConferenteLogin from './pages/ConferentePWA/ConferenteLogin';
import ConferenteCadastroLogin from './pages/ConferentePWA/ConferenteCadastroLogin';
import ConferenteDashboard from './pages/ConferentePWA/ConferenteDashboard';
import ConferenteScanner from './pages/ConferentePWA/ConferenteScanner';
import ConferenteHistorico from './pages/ConferentePWA/ConferenteHistorico';
import { isConferenteLoggedIn, getConferenteLoginUrl, isConferenteTokenExpired, handleConferenteSessionExpired } from './services/conferente';
import MotoristaLogin from './pages/MotoristaPWA/MotoristaLogin';
import MotoristaDashboard from './pages/MotoristaPWA/MotoristaDashboard';
import MotoristaChecklist from './pages/MotoristaPWA/MotoristaChecklist';
import MotoristaHistorico from './pages/MotoristaPWA/MotoristaHistorico';
import { isMotoristaLoggedIn } from './services/motoristaAuth';
import { isClientLoggedIn } from './services/clientDashboard';
import ClientLogin from './pages/ClientDashboard/ClientLogin';
import ClientDashboardLayout from './pages/ClientDashboard/ClientDashboardLayout';
import ClienteUsuariosAdmin from './pages/Clientes/ClienteUsuariosAdmin';

import MontagemPaleteList from './pages/MontagemPaletes/MontagemPaleteList';
import MontagemPaleteCreate from './pages/MontagemPaletes/Create/MontagemPaleteCreate';
import MontagemPaleteView from './pages/MontagemPaletes/View/MontagemPaleteView';
import MontagemPaleteFiliais from './pages/MontagemPaletes/Filiais/MontagemPaleteFiliais';
import MontagemPaleteAreas from './pages/MontagemPaletes/Areas/MontagemPaleteAreas';
import MontagemPaleteEdit from './pages/MontagemPaletes/Edit/MontagemPaleteEdit';
import MontagemPaleteAgendamentos from './pages/MontagemPaletes/Agendamentos/MontagemPaleteAgendamentos';
import PaleteListPage from './pages/MontagemPaletes/Paletes/PaleteListPage';
import PreCarregamentoConferencia from './pages/Conferencia/PreCarregamento/PreCarregamentoConferencia';
import CarregamentoConferencia from './pages/Conferencia/Carregamento/CarregamentoConferencia';
import DescarregamentoConferencia from './pages/Conferencia/Descarregamento/DescarregamentoConferencia';
import NaoConformidadesList from './pages/NaoConformidades/NaoConformidadesList';
import ConferenciaRelatoriosPage from './pages/Conferencia/Relatorios/RelatoriosPage';
import ConfiguracoesConferencia from './pages/Conferencia/Configuracoes/ConfiguracoesConferencia';
import ConferentesList from './pages/Conferentes/ConferentesList';
import OperationalDashboardLayout from './pages/OperationalDashboard/OperationalDashboardLayout';
import TiposOcorrenciaList from './pages/Conferencia/TiposOcorrencia/TiposOcorrenciaList';
import EtiquetasList from './pages/Etiquetas/EtiquetasList';
import EtiquetaView from './pages/Etiquetas/EtiquetaView';
import EtiquetaForm from './pages/Etiquetas/EtiquetaForm';
import './styles/styles.css';
import './styles/erp-theme.css'; // Camada de padronização visual ERP (carregada por último)

// Módulos Fase 6-7 (lazy loading)
const MultasList = React.lazy(() => import('./pages/Multas/MultasList'));
const SinistrosList = React.lazy(() => import('./pages/Sinistros/SinistrosList'));
const EstoqueList = React.lazy(() => import('./pages/Estoque/EstoqueList'));
const ComprasList = React.lazy(() => import('./pages/Compras/ComprasList'));
const TacografosList = React.lazy(() => import('./pages/Tacografos/TacografosList'));
const ScoringMotoristas = React.lazy(() => import('./pages/Scoring/ScoringMotoristas'));
const DashboardCombustivel = React.lazy(() => import('./pages/DashboardCombustivel/DashboardCombustivel'));
const TelematicaPage = React.lazy(() => import('./pages/Telematica/TelematicaPage'));
const RodizioRecapagem = React.lazy(() => import('./pages/Pneus/RodizioRecapagem'));

// Componente de rota protegida com Layout
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

// Componente de rota pública (redireciona se autenticado)
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return !isAuthenticated ? <>{children}</> : <Navigate to="/dashboard" replace />;
};

// Componente para rotas que não requerem autenticação mas permitem acesso de qualquer forma
// (útil para reset de senha, onde usuário pode estar logado ou não)
const OpenRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

// Componente de rota protegida para o PWA do Conferente (usa token próprio)
// Verifica expiração do token periodicamente e ao voltar ao app (visibilitychange)
const ConferenteRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  React.useEffect(() => {
    // Verifica expiração a cada 30 segundos
    const interval = setInterval(() => {
      if (isConferenteTokenExpired()) {
        handleConferenteSessionExpired();
      }
    }, 30000);

    // Verifica ao voltar ao app (ex: troca de aba ou desbloqueio de tela)
    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && isConferenteTokenExpired()) {
        handleConferenteSessionExpired();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return isConferenteLoggedIn() ? <>{children}</> : <Navigate to={getConferenteLoginUrl()} replace />;
};

// Rota protegida para motoristas (PWA)
const MotoristaRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return isMotoristaLoggedIn() ? <>{children}</> : <Navigate to="/motorista/login" replace />;
};

// Componente de rota protegida para o Dashboard do Cliente
const ClientRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return isClientLoggedIn() ? <>{children}</> : <Navigate to="/cliente/login" replace />;
};

const AppContent: React.FC = () => {
  return (
    <div className="app">
      <Routes>
        {/* Rota pública - Login */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* Rota aberta - Redefinição de Senha (acessível logado ou não) */}
        <Route
          path="/redefinir-senha"
          element={
            <OpenRoute>
              <ResetPassword />
            </OpenRoute>
          }
        />

        {/* Rota aberta - Confirmação de Email (acessível logado ou não) */}
        <Route
          path="/confirmar-email"
          element={
            <OpenRoute>
              <ConfirmEmail />
            </OpenRoute>
          }
        />

        {/* Rota pública - Scanner QR Code para identificação de veículos/equipamentos */}
        <Route
          path="/qr-scanner"
          element={
            <OpenRoute>
              <QRScanner />
            </OpenRoute>
          }
        />

        {/* Rota de Acesso Negado */}
        <Route
          path="/acesso-negado"
          element={
            <ProtectedRoute>
              <AccessDenied />
            </ProtectedRoute>
          }
        />

        {/* Rota protegida - Dashboard */}
        <Route
          path="/dashboard"
          element={
            <PermissionRoute module={SystemModule.DASHBOARD}>
              <Dashboard />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Obras */}
        <Route
          path="/obras"
          element={
            <PermissionRoute module={SystemModule.OBRAS}>
              <Obras />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Obra */}
        <Route
          path="/obras/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.OBRAS}>
              <ObraView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Obra */}
        <Route
          path="/obras/novo"
          element={
            <PermissionRoute module={SystemModule.OBRAS}>
              <ObraCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Obra */}
        <Route
          path="/obras/editar/:id"
          element={
            <PermissionRoute module={SystemModule.OBRAS}>
              <ObraEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Checklists */}
        <Route
          path="/checklists"
          element={
            <PermissionRoute module={SystemModule.CHECKLISTS}>
              <Checklists />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Checklist */}
        <Route
          path="/checklists/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.CHECKLISTS}>
              <ChecklistView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Checklist */}
        <Route
          path="/checklists/novo"
          element={
            <PermissionRoute module={SystemModule.CHECKLISTS}>
              <ChecklistCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Checklist */}
        <Route
          path="/checklists/editar/:id"
          element={
            <PermissionRoute module={SystemModule.CHECKLISTS}>
              <ChecklistEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Automações WhatsApp */}
        <Route
          path="/automacoes"
          element={
            <PermissionRoute module={SystemModule.AUTOMACAO_EDITOR}>
              <AutomationList />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criar Automação */}
        <Route
          path="/automacoes/novo"
          element={
            <PermissionRoute module={SystemModule.AUTOMACAO_EDITOR}>
              <AutomationCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Editar Automação */}
        <Route
          path="/automacoes/editar/:id"
          element={
            <PermissionRoute module={SystemModule.AUTOMACAO_EDITOR}>
              <AutomationEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Simulador de Fluxos */}
        <Route
          path="/automacoes/simulador"
          element={
            <PermissionRoute module={SystemModule.AUTOMACAO_SIMULADOR}>
              <FlowSimulatorPage />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Execuções de Automação */}
        <Route
          path="/automacoes/execucoes"
          element={
            <PermissionRoute module={SystemModule.AUTOMACAO_EDITOR}>
              <AutomationExecutions />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Motoristas */}
        <Route
          path="/motoristas"
          element={
            <PermissionRoute module={SystemModule.MOTORISTAS}>
              <Drivers />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Motorista */}
        <Route
          path="/motoristas/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.MOTORISTAS}>
              <DriverView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Motorista */}
        <Route
          path="/motoristas/novo"
          element={
            <PermissionRoute module={SystemModule.MOTORISTAS}>
              <DriverCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Motorista */}
        <Route
          path="/motoristas/editar/:id"
          element={
            <PermissionRoute module={SystemModule.MOTORISTAS}>
              <DriverEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Veículos */}
        <Route
          path="/veiculos"
          element={
            <PermissionRoute module={SystemModule.VEICULOS}>
              <Vehicles />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Veículo */}
        <Route
          path="/veiculos/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.VEICULOS}>
              <VehicleView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Veículo */}
        <Route
          path="/veiculos/novo"
          element={
            <PermissionRoute module={SystemModule.VEICULOS}>
              <VehicleCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Veículo */}
        <Route
          path="/veiculos/editar/:id"
          element={
            <PermissionRoute module={SystemModule.VEICULOS}>
              <VehicleEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Equipamentos */}
        <Route
          path="/equipamentos"
          element={
            <PermissionRoute module={SystemModule.EQUIPAMENTOS}>
              <Equipment />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Equipamento */}
        <Route
          path="/equipamentos/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.EQUIPAMENTOS}>
              <EquipmentView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Equipamento */}
        <Route
          path="/equipamentos/novo"
          element={
            <PermissionRoute module={SystemModule.EQUIPAMENTOS}>
              <EquipmentCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Equipamento */}
        <Route
          path="/equipamentos/editar/:id"
          element={
            <PermissionRoute module={SystemModule.EQUIPAMENTOS}>
              <EquipmentEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Itens de Checklist */}
        <Route
          path="/itens-checklist"
          element={
            <PermissionRoute module={SystemModule.ITENS_CHECKLIST}>
              <ChecklistItems />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Item de Checklist */}
        <Route
          path="/itens-checklist/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.ITENS_CHECKLIST}>
              <ChecklistItemView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Item de Checklist */}
        <Route
          path="/itens-checklist/novo"
          element={
            <PermissionRoute module={SystemModule.ITENS_CHECKLIST}>
              <ChecklistItemCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Item de Checklist */}
        <Route
          path="/itens-checklist/editar/:id"
          element={
            <PermissionRoute module={SystemModule.ITENS_CHECKLIST}>
              <ChecklistItemEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Grupos de Checklist */}
        <Route
          path="/grupos-checklist"
          element={
            <PermissionRoute module={SystemModule.GRUPOS_CHECKLIST}>
              <ChecklistGroups />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Grupo de Checklist */}
        <Route
          path="/grupos-checklist/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.GRUPOS_CHECKLIST}>
              <ChecklistGroupView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Grupo de Checklist */}
        <Route
          path="/grupos-checklist/novo"
          element={
            <PermissionRoute module={SystemModule.GRUPOS_CHECKLIST}>
              <ChecklistGroupCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Grupo de Checklist */}
        <Route
          path="/grupos-checklist/editar/:id"
          element={
            <PermissionRoute module={SystemModule.GRUPOS_CHECKLIST}>
              <ChecklistGroupEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Ocorrências */}
        <Route
          path="/ocorrencias"
          element={
            <PermissionRoute module={SystemModule.OCORRENCIAS}>
              <Occurrences />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Ocorrência */}
        <Route
          path="/ocorrencias/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.OCORRENCIAS}>
              <OccurrenceView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Ocorrência */}
        <Route
          path="/ocorrencias/nova"
          element={
            <PermissionRoute module={SystemModule.OCORRENCIAS}>
              <OccurrenceCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Ocorrência */}
        <Route
          path="/ocorrencias/editar/:id"
          element={
            <PermissionRoute module={SystemModule.OCORRENCIAS}>
              <OccurrenceEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Agendamentos */}
        <Route
          path="/agendamentos"
          element={
            <PermissionRoute module={SystemModule.AGENDAMENTOS}>
              <Schedules />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Novo Agendamento */}
        <Route
          path="/agendamentos/novo"
          element={
            <PermissionRoute module={SystemModule.AGENDAMENTOS}>
              <ScheduleForm />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Agendamento */}
        <Route
          path="/agendamentos/editar/:id"
          element={
            <PermissionRoute module={SystemModule.AGENDAMENTOS}>
              <ScheduleForm />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Agendamento */}
        <Route
          path="/agendamentos/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.AGENDAMENTOS}>
              <ScheduleView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Abastecimentos */}
        <Route
          path="/abastecimentos"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <Fueling />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Abastecimento */}
        <Route
          path="/abastecimentos/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <FuelingView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Criação de Abastecimento */}
        <Route
          path="/abastecimentos/novo"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <FuelingCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Abastecimento */}
        <Route
          path="/abastecimentos/editar/:id"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <FuelingEdit />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Histórico de Importações CTA Smart */}
        <Route
          path="/abastecimentos/importacoes"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <ImportHistory />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Produtividade */}
        <Route
          path="/produtividade"
          element={
            <PermissionRoute module={SystemModule.PRODUTIVIDADE}>
              <Productivity />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Produtividade */}
        <Route
          path="/produtividade/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.PRODUTIVIDADE}>
              <ProductivityView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Cadastro de Produtividade */}
        <Route
          path="/produtividade/novo"
          element={
            <PermissionRoute module={SystemModule.PRODUTIVIDADE}>
              <ProductivityCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Manutenções Preventivas */}
        <Route
          path="/manutencoes-preventivas"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_PREVENTIVAS}>
              <PreventiveMaintenance />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Manutenção Preventiva */}
        <Route
          path="/manutencoes-preventivas/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_PREVENTIVAS}>
              <PreventiveMaintenanceView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Cadastro de Manutenção Preventiva */}
        <Route
          path="/manutencoes-preventivas/novo"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_PREVENTIVAS}>
              <PreventiveMaintenanceCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Manutenção Preventiva (reutiliza o componente de cadastro em modo dual) */}
        <Route
          path="/manutencoes-preventivas/editar/:id"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_PREVENTIVAS}>
              <PreventiveMaintenanceCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Manutenções Corretivas */}
        <Route
          path="/manutencoes-corretivas"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_CORRETIVAS}>
              <CorrectiveMaintenance />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Visualização de Manutenção Corretiva */}
        <Route
          path="/manutencoes-corretivas/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_CORRETIVAS}>
              <CorrectiveMaintenanceView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Cadastro de Manutenção Corretiva */}
        <Route
          path="/manutencoes-corretivas/novo"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_CORRETIVAS}>
              <CorrectiveMaintenanceCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Edição de Manutenção Corretiva (reutiliza o componente de cadastro em modo dual) */}
        <Route
          path="/manutencoes-corretivas/editar/:id"
          element={
            <PermissionRoute module={SystemModule.MANUTENCOES_CORRETIVAS}>
              <CorrectiveMaintenanceCreate />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Pneus */}
        <Route
          path="/pneus"
          element={
            <PermissionRoute module={SystemModule.PNEUS}>
              <Tires />
            </PermissionRoute>
          }
        />

        <Route
          path="/pneus/novo"
          element={
            <PermissionRoute module={SystemModule.PNEUS}>
              <TireCreate />
            </PermissionRoute>
          }
        />

        <Route
          path="/pneus/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.PNEUS}>
              <TireView />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Compliance */}
        <Route
          path="/compliance"
          element={
            <PermissionRoute module={SystemModule.COMPLIANCE}>
              <Compliance />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - TCO */}
        <Route
          path="/tco"
          element={
            <PermissionRoute module={SystemModule.TCO}>
              <TCO />
            </PermissionRoute>
          }
        />

        {/* Rotas Fase 6-7: Multas, Sinistros, Estoque, Compras, Tacografos, Scoring, Dashboard Combustivel, Telematica, Rodizio/Recapagem */}
        <Route path="/multas" element={<PermissionRoute module={SystemModule.MULTAS}><React.Suspense fallback={<div>Carregando...</div>}><MultasList /></React.Suspense></PermissionRoute>} />
        <Route path="/sinistros" element={<PermissionRoute module={SystemModule.SINISTROS}><React.Suspense fallback={<div>Carregando...</div>}><SinistrosList /></React.Suspense></PermissionRoute>} />
        <Route path="/estoque" element={<PermissionRoute module={SystemModule.ESTOQUE}><React.Suspense fallback={<div>Carregando...</div>}><EstoqueList /></React.Suspense></PermissionRoute>} />
        <Route path="/compras" element={<PermissionRoute module={SystemModule.COMPRAS}><React.Suspense fallback={<div>Carregando...</div>}><ComprasList /></React.Suspense></PermissionRoute>} />
        <Route path="/tacografos" element={<PermissionRoute module={SystemModule.TACOGRAFOS}><React.Suspense fallback={<div>Carregando...</div>}><TacografosList /></React.Suspense></PermissionRoute>} />
        <Route path="/scoring" element={<PermissionRoute module={SystemModule.SCORING_MOTORISTAS}><React.Suspense fallback={<div>Carregando...</div>}><ScoringMotoristas /></React.Suspense></PermissionRoute>} />
        <Route path="/dashboard-combustivel" element={<PermissionRoute module={SystemModule.DASHBOARD_COMBUSTIVEL}><React.Suspense fallback={<div>Carregando...</div>}><DashboardCombustivel /></React.Suspense></PermissionRoute>} />
        <Route path="/telematica" element={<PermissionRoute module={SystemModule.TELEMATICA}><React.Suspense fallback={<div>Carregando...</div>}><TelematicaPage /></React.Suspense></PermissionRoute>} />
        <Route path="/pneus/rodizio-recapagem" element={<PermissionRoute module={SystemModule.RODIZIO_RECAPAGEM}><React.Suspense fallback={<div>Carregando...</div>}><RodizioRecapagem /></React.Suspense></PermissionRoute>} />

        {/* Rota protegida - Relatório de Produtividade de Equipamentos */}
        <Route
          path="/relatorios/produtividade-equipamentos"
          element={
            <PermissionRoute module={SystemModule.RELATORIO_PRODUTIVIDADE_EQUIPAMENTOS}>
              <EquipmentProductivity />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Relatório de Checklists */}
        <Route
          path="/relatorios/checklists"
          element={
            <PermissionRoute module={SystemModule.RELATORIO_CHECKLISTS}>
              <ChecklistsReport />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Relatório de Veículos */}
        <Route
          path="/relatorios/veiculos"
          element={
            <PermissionRoute module={SystemModule.RELATORIO_VEICULOS}>
              <VehiclesReport />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Relatório de Ocorrências */}
        <Route
          path="/relatorios/ocorrencias"
          element={
            <PermissionRoute module={SystemModule.RELATORIO_OCORRENCIAS}>
              <OccurrencesReport />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Relatório de Abastecimentos */}
        <Route
          path="/relatorios/abastecimentos"
          element={
            <PermissionRoute module={SystemModule.ABASTECIMENTOS}>
              <FuelReport />
            </PermissionRoute>
          }
        />

        {/* Rotas protegidas - Clientes (Conferência de Carga) */}
        <Route
          path="/clientes"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ClientesList />
            </PermissionRoute>
          }
        />
        <Route
          path="/clientes/novo"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ClienteCreate />
            </PermissionRoute>
          }
        />
        <Route
          path="/clientes/visualizar/:id"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ClienteView />
            </PermissionRoute>
          }
        />
        <Route
          path="/clientes/editar/:id"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ClienteEdit />
            </PermissionRoute>
          }
        />

        {/* Rotas protegidas - Conferência de Carga */}
        <Route
          path="/conferencia"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaList />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/pre-carregamento"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <PreCarregamentoConferencia />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/carregamento"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <CarregamentoConferencia />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/descarregamento"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <DescarregamentoConferencia />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/novo"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaCreate />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/:id"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaView />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/:id/editar"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaEdit />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/:id/scanner"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaScanner />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/produtividade"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaProdutividade />
            </PermissionRoute>
          }
        />
        <Route
          path="/conferencia/produtividade/:usuarioId"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaProdutividadeDetalhe />
            </PermissionRoute>
          }
        />

        {/* Montagem de Paletes */}
        <Route
          path="/montar-carga"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteList />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/novo"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteCreate />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/filiais"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteFiliais />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/areas"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteAreas />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/agendamentos"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteAgendamentos />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/paletes"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <PaleteListPage />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/:id/editar"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteEdit />
            </PermissionRoute>
          }
        />
        <Route
          path="/montar-carga/:id"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <MontagemPaleteView />
            </PermissionRoute>
          }
        />

        {/* Dashboard Operacional */}
        <Route
          path="/dashboard-operacional"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <OperationalDashboardLayout />
            </PermissionRoute>
          }
        />

        {/* Gestao de Conferentes */}
        <Route
          path="/conferentes"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferentesList />
            </PermissionRoute>
          }
        />

        {/* Configurações de Conferência */}
        <Route
          path="/conferencia/configuracoes"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConfiguracoesConferencia />
            </PermissionRoute>
          }
        />

        {/* Nao Conformidades */}
        <Route
          path="/nao-conformidades"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <NaoConformidadesList />
            </PermissionRoute>
          }
        />

        {/* Relatorios Conferencia */}
        <Route
          path="/conferencia/relatorios"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ConferenciaRelatoriosPage />
            </PermissionRoute>
          }
        />

        {/* Ocorrências */}
        <Route
          path="/tipos-ocorrencia-divergencia"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_DIVERGENCIAS}>
              <TiposOcorrenciaList />
            </PermissionRoute>
          }
        />

        {/* Pedidos */}
        <Route
          path="/pedidos"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <EtiquetasList />
            </PermissionRoute>
          }
        />
        <Route
          path="/pedidos/novo"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <EtiquetaForm />
            </PermissionRoute>
          }
        />
        <Route
          path="/pedidos/:id/editar"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <EtiquetaForm />
            </PermissionRoute>
          }
        />
        <Route
          path="/pedidos/:id"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <EtiquetaView />
            </PermissionRoute>
          }
        />

        {/* Rotas do Dashboard do Cliente (sem Layout/Sidebar) */}
        <Route path="/cliente/login" element={<ClientLogin />} />
        <Route path="/cliente/dashboard" element={<ClientRoute><ClientDashboardLayout /></ClientRoute>} />

        {/* Rota protegida - Gerenciamento de Usuários do Cliente (admin) */}
        <Route
          path="/clientes/:clienteId/usuarios"
          element={
            <PermissionRoute module={SystemModule.CONFERENCIA_CARGA}>
              <ClienteUsuariosAdmin />
            </PermissionRoute>
          }
        />

        {/* Rotas PWA do Conferente (sem Layout/Sidebar) */}
        <Route path="/conferente/login" element={<ConferenteLogin />} />
        <Route path="/conferente/:cnpj" element={<ConferenteCadastroLogin />} />
        <Route path="/conferente" element={<ConferenteRoute><ConferenteDashboard /></ConferenteRoute>} />
        <Route path="/conferente/pre_carregamento" element={<ConferenteRoute><PreCarregamentoConferencia backUrl="/conferente" /></ConferenteRoute>} />
        <Route path="/conferente/carregamento" element={<ConferenteRoute><CarregamentoConferencia backUrl="/conferente" /></ConferenteRoute>} />
        <Route path="/conferente/descarregamento" element={<ConferenteRoute><DescarregamentoConferencia backUrl="/conferente" /></ConferenteRoute>} />
        <Route path="/conferente/historico" element={<ConferenteRoute><ConferenteHistorico /></ConferenteRoute>} />
        <Route path="/conferente/conferencia/:id" element={<ConferenteRoute><ConferenteScanner /></ConferenteRoute>} />

        {/* Rotas PWA do Motorista (sem Layout/Sidebar) */}
        {/* Rota com slug da empresa: /motorista/{slug}/login */}
        <Route path="/motorista/:slug/login" element={<MotoristaLogin />} />
        {/* Rota legada sem slug (mantida para compatibilidade) */}
        <Route path="/motorista/login" element={<MotoristaLogin />} />
        <Route path="/motorista" element={<MotoristaRoute><MotoristaDashboard /></MotoristaRoute>} />
        <Route path="/motorista/checklist" element={<MotoristaRoute><MotoristaChecklist /></MotoristaRoute>} />
        <Route path="/motorista/historico" element={<MotoristaRoute><MotoristaHistorico /></MotoristaRoute>} />

        {/* Rota protegida - Configurações */}
        <Route
          path="/configuracoes"
          element={
            <PermissionRoute module={SystemModule.CONFIGURACOES}>
              <Settings />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - WhatsApp */}
        <Route
          path="/configuracoes/whatsapp"
          element={
            <PermissionRoute module={SystemModule.CONFIG_WHATSAPP}>
              <WhatsApp />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Contatos Não Identificados */}
        <Route
          path="/configuracoes/whatsapp/contatos-nao-identificados"
          element={
            <PermissionRoute module={SystemModule.CONFIG_WHATSAPP}>
              <ContatosNaoIdentificados />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Gerenciamento de Usuários */}
        <Route
          path="/configuracoes/usuarios"
          element={
            <PermissionRoute module={SystemModule.USUARIOS}>
              <UserManagement />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Configurações da Empresa */}
        <Route
          path="/configuracoes/sistema"
          element={
            <PermissionRoute module={SystemModule.CONFIG_SISTEMA}>
              <CompanySettings />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Backup e Downloads */}
        <Route
          path="/configuracoes/backup"
          element={
            <PermissionRoute module={SystemModule.CONFIG_BACKUP}>
              <Backup />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Configurações de Integrações */}
        <Route
          path="/configuracoes/integracoes"
          element={
            <PermissionRoute module={SystemModule.CONFIG_INTEGRACOES}>
              <IntegrationSettings />
            </PermissionRoute>
          }
        />

        {/* Rota protegida - Perfil do Usuário */}
        <Route
          path="/perfil"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />

        {/* Rota protegida - Notificações */}
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Notifications />
            </ProtectedRoute>
          }
        />

        {/* Rota protegida - Configurações de Privacidade */}
        <Route
          path="/privacidade"
          element={
            <ProtectedRoute>
              <PrivacySettings />
            </ProtectedRoute>
          }
        />

        {/* Rota padrão - redireciona para dashboard se autenticado, senão para login */}
        <Route
          path="/"
          element={<Navigate to="/dashboard" replace />}
        />

        {/* Rota 404 */}
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;
